import { graphql } from 'react-relay';

export default graphql`
  query App_Query {
    viewer {
      id
      id
      user {
        id
        id
      }
    }
  }
`;
